import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-628d6b43"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hi_there" }, "!Hello¡", -1))
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "buttom__live" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_buttom = _resolveComponent("l-buttom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.user), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_l_buttom, {
        class: "live__preview",
        onClick: _cache[0] || (_cache[0] = () => this.$router.push(`/${_ctx.user}`)),
        text: "Vista previa"
      })
    ])
  ]))
}